import React from 'react';
import '../../../styles/modes/setupMode.css';

const ModeHelpTooltip = ({ onClose }) => {
  return (
    <div className="mode-help-overlay">
      <div className="mode-help-content">
        <h4>Setup Points Mode Help</h4>
        <button className="close-button" onClick={onClose}>×</button>
        <div className="help-text">
          <p><strong>Purpose:</strong> This is the first step in solving Traveling Salesman Problems (TSP). Set up all location points that need to be visited in the shortest possible tour.</p>
          
          <p><strong>Three Ways to Add Points:</strong></p>
          
          <p><strong>Method 1: Map Points</strong></p>
          <ol>
            <li>Click "Map Points" tab (default mode)</li>
            <li>Click directly on the map to add location points</li>
            <li>Points are automatically numbered sequentially</li>
            <li>Continue clicking to add all locations to visit</li>
          </ol>

          <p><strong>Method 2: Manual Input</strong></p>
          <ol>
            <li>Click "Manual Input" tab</li>
            <li>Enter precise latitude and longitude coordinates</li>
            <li>Click "Add" button to create the point</li>
            <li>Useful for exact coordinate placement</li>
          </ol>

          <p><strong>Method 3: Load Points</strong></p>
          <ol>
            <li>Click "Load Points" button</li>
            <li>Select a JSON file with saved points</li>
            <li>System imports and restores all points</li>
            <li>Best for loading existing configurations</li>
          </ol>

          <p><strong>Set Start Point:</strong></p>
          <ul>
            <li>Click "S" button next to any point to set as start point</li>
            <li>Start point is where the tour begins and ends</li>
            <li>TSP creates a closed loop returning to start</li>
            <li>Setting a start point is required for routing</li>
          </ul>

          <p><strong>Manage Points:</strong></p>
          <ul>
            <li>View all added points in Location Points list</li>
            <li>Edit point names by clicking on them</li>
            <li>Delete unwanted points using × button</li>
            <li>Download configuration to save your work</li>
            <li>Reset to clear all points and start over</li>
          </ul>

          <p><strong>TSP Key Concepts:</strong></p>
          <ul>
            <li><strong>TSP (Traveling Salesman Problem):</strong> Find the shortest route visiting all points exactly once</li>
            <li><strong>Start Point:</strong> Where tour begins and ends (depot)</li>
            <li><strong>Customer Points:</strong> All other locations to visit</li>
            <li><strong>Closed Tour:</strong> Route returns to starting point after visiting all locations</li>
          </ul>

          <p><strong>Complete TSP Workflow:</strong></p>
          <ol>
            <li><strong>Step 1: Setup Points (Current)</strong> - Add all locations and set start point</li>
            <li><strong>Step 2a: Auto Find Path</strong> - Use algorithms to find optimal tour</li>
            <li><strong>Step 2b: Custom Path</strong> - Manually design your own tour</li>
            <li><strong>Step 3: Compare Mode</strong> - Compare auto vs manual solutions</li>
          </ol>

          <p><strong>Tips:</strong></p>
          <ul>
            <li>Minimum 3 points required for meaningful TSP routes</li>
            <li>More points = more complex optimization problem</li>
            <li>Use descriptive names for easy identification</li>
            <li>Save configuration regularly using Download</li>
            <li>JSON format preserves all point properties including start point</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default ModeHelpTooltip; 